export default {
	namespaced: true,
	state: {
		breadcrumb: []
	},
	getters: {
		breadcrumb: state => state.breadcrumb
	},
	mutations: {
		mutate(state, payload) {
			state[payload.element] = payload.value
		}
	},

	actions: {
		doMutate({ commit }, payload) {
			commit("mutate", payload)
		}
	}
}
